import { render, staticRenderFns } from "./xj.vue?vue&type=template&id=4ffe840a&scoped=true&"
import script from "./xj.vue?vue&type=script&lang=js&"
export * from "./xj.vue?vue&type=script&lang=js&"
import style0 from "./xj.vue?vue&type=style&index=0&id=4ffe840a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe840a",
  null
  
)

component.options.__file = "xj.vue"
export default component.exports